export const ROLE_LABELS = {
  super_admin: 'Super Admin',
  court_admin: 'Court Admin',
  registrar: 'Registrar',
  judge: 'Judge',
  reviewer: 'Reviewer',
  magistrate: 'Magistrate',
};

export const COURT_ADMIN_ASSIGNABLE_ROLES = [
  { value: 'court_admin', label: 'Court Admin' },
  { value: 'registrar', label: 'Registrar' },
  { value: 'judge', label: 'Judge' },
  { value: 'reviewer', label: 'Reviewer' },
];

export const getRoleLabel = (role) =>
  ROLE_LABELS[String(role || '').toLowerCase().replace(/\s+/g, '_')] ||
  String(role || '').replace(/_/g, ' ');
